export const EXCEL = 'excel';
export const PDF = 'pdf';
export const ERROR = 'success';
export const SUCCESS = 'error';
export const DEFAULT = 'default';
export const ABOVE = 'Above Peer Cost (High)';
export const TYPICAL = 'Typical Cost (In Line)';
export const BELOW = 'Below Peer Cost (Low)';
export const COST_BENCHMARK_PAGE_LENGTH = 30;
export const CHART_X_LABEL = 'Approx. Peer Median Cost per Capita ($)';
export const CHART_Y_LABEL = 'Your Cost per Capita ($)';
export const THRESHOLD = 'threshold';

export const DOC_GENERATOR_SOCKET = {
  EXPORT_COST_BENCHMARK_DATA_PDF: 'exportCostBenchmarkDataPdf',
  EXPORT_COST_BENCHMARK_DATA_EXCEL: 'exportCostBenchmarkDataExcel',
};
